import { observer } from 'mobx-react';
import { FormFieldLine } from '../../../../../../components/form-field-line/form-field-line';
import { Input } from '../../../../../../components/inputs/input/input';
import { IValidationGroup } from '../../../../../../hooks/validation-group/validation-group-hook';
import FreshdeskCredentialsStore from '../../../stores/credentials/freshdesk-credentials-store';

interface IIntegrationProps {
    credentialsStore: FreshdeskCredentialsStore,
    vGroup: IValidationGroup,
}

const FreshdeskCredentials: React.FC<IIntegrationProps> = observer(({credentialsStore, vGroup}) => {
    return (
        <>
            <FormFieldLine label='Freshdesk API key' required key='api_key'>
                <Input
                    value={credentialsStore.api_key}
                    onChange={v => credentialsStore.api_key = v}
                    validationGroup={vGroup}
                    adornment={''}
                    required
                />
            </FormFieldLine>
            <FormFieldLine label='Freshdesk company name (domain name)' required key='company'>
                <Input
                    value={credentialsStore.company}
                    onChange={v => credentialsStore.company = v}
                    validationGroup={vGroup}
                    adornment={''}
                    required
                />
            </FormFieldLine>
        </>
    )
});

export default FreshdeskCredentials;
